import GenericSort, { SortOption } from 'components/DropdownSelectors/GenericSingleSelector/GenericSort'
import Translation from 'components/Translation'
import { CSSProperties } from 'react'
import { classNames } from 'utils/dom-helpers'

export type DataTableColumnProps = {
    label?: string 
    checkAll?(): void
    classNames: string
    style?: CSSProperties
    setSortOption?: (sort_option: SortOption) => void
    sort_options?: SortOption[]
    sort_option?: SortOption
    renderHeader?: () => JSX.Element
}

export type DataTableProps = {
    columns: DataTableColumnProps[]
    rows: HTMLTableRowElement[]
    all_selected?: boolean
    table_class_names?: string
    head_class_names?: string
    body_class_names?: string
}
export function DataTable({
    columns,
    rows,
    all_selected = false,
    table_class_names = "",
    head_class_names = "",
    body_class_names = ""
}: DataTableProps) {
    return (
        <table className={classNames(table_class_names, "min-w-full divide-y divide-gray-200 custom-table-colors")}>
            <thead className={classNames(head_class_names, "bg-primary-lighter")}>
                <tr>
                    {columns.map((col: DataTableColumnProps, idx) => (
                        <th
                            key={idx}
                            scope="col"
                            className={
                                classNames(col.classNames, "font-semibold text-gray-900") ||
                                'py-3 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider'
                            }
                            style={col.style}
                        >

                            {col.sort_options && col.setSortOption ?
                                <GenericSort
                                    options={col.sort_options}
                                    setSortOption={col.setSortOption}
                                    name={col.label || ""}
                                    sort_option={col.sort_option}
                                />
                                :
                                <Translation content_key={col.label || ""} />
                            }
                            {col.checkAll ? (
                                <input
                                    type="checkbox"
                                    className="h-6 w-6 m-2 border-gray-300 rounded text-primary focus:ring-primary-light disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-three"
                                    onChange={col.checkAll}
                                    checked={all_selected}
                                />
                            ) : (
                                ''
                            )}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody className={classNames(body_class_names, "bg-white divide-y divide-gray-200")}>
                {rows}
            </tbody>
        </table>
    )
}

export default DataTable
